export enum SavedQueryType {
    DATA_EXTRACT_BY_ACCOUNT = 'Operations - Data Extract By Account',
    GET_PREVIOUS_DAYS_SHIPMENTS = 'Operations - Get Previous Days Shipments',
    GET_LEAST_COST_EXCEPTIONS = 'Operations - Get Least Cost Exceptions',
    GET_BOOKED_SHIPMENTS_COUNT_BY_USER = 'Operations - Get Booked Shipments Count By User',
    DAILY_ITEMIZED_SUMMARY_WITH_PIECE_COUNT = 'Operations - Daily Itemized Summary with Piece Count',
    TENDER_REJECTION_DATA_EXTRACT = 'Operations - Tender Rejection Data Extract',
    GET_CARRIER_TOTALS_BY_YEAR_MONTH = 'Operations - Get Carrier Totals by Year-Month',
    GET_CUSTOMER_ACTIVITY = 'Operations - Get Customer Activity',
    MONTHLY_TMS_EXC_YTD = 'Operations - Monthly TMS and EXC YTD Report (client activity)',
    SPOT_MARKET_BID_DATA_EXTRACT = 'Operations - Spot Market Bid Data Extract',
    LAST_104_WEEKS_OF_DIESEL = 'Operations - Get last 104 weeks of diesel averages',
    UPDATE_TL_CONTRACT_TO_FLAT_FEE = 'Operations - Update TL Contract to Flat Fee',
    ADD_FEDEX_FREIGHT_ECONOMY = 'Operations - Add FedEx Freight Economy I/O/T Contracts',
    SERVICE_INCIDENT_DATA_EXTRACT = 'Operations - Service Incident Data Extract',
}